import React from "react";

const Footer = () => {
  return (
    <div
      className="footer py-4"
      style={{
        background:
          "linear-gradient(273.25deg, #032044 23.04%, rgba(3, 57, 124, 0.892717) 101.15%, rgba(3, 115, 255, 0.77) 180.14%, rgba(0, 62, 139, 0) 221.97%",
      }}
    >
      <h5 className="text-center pb-2" style={{ color: "white" }}>
        Follow us on
      </h5>
      <div className="social-icons  d-flex justify-content-center">
        <a
          href="https://www.facebook.com/bipin.gala.28"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="Images/Icons/fb.png"
            alt=""
            height="30px"
            className="mx-2"
          />
        </a>
        <a
          href="https://www.instagram.com/bng28"
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          <img
            src="Images/Icons/insta.png"
            alt=""
            height="30px"
            className="mx-2"
          />
        </a>
        <a
          href="https://www.linkedin.com/in/bipin-gala-400a58194"
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          <img
            src="Images/Icons/linkedin.png"
            alt=""
            height="30px"
            className="mx-2"
          />
        </a>
        <a href="# ">
          {" "}
          <img
            src="Images/Icons/twitter-icon.png"
            alt=""
            height="30px"
            className="mx-2"
          />
        </a>
      </div>
    </div>
  );
};

export default Footer;
